export default "__VITE_ASSET__RC0tWGJc__$_?url__"